import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TS_ChuyenNganhTotNghiep } from '../../services/chuyen-nganh-tot-nghiep/ChuyenNganhTotNghiepModels';

interface ChuyenNganhTotNghiepState {
    listData: TS_ChuyenNganhTotNghiep[];
    selectedId: number | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    isShowCreateOrEditModal: boolean;
    createOrEditModel: TS_ChuyenNganhTotNghiep | null;
    isShowConfirmDeleteModal: boolean;
}

const initialState: ChuyenNganhTotNghiepState = {
    listData: [],
    selectedId: null,
    status: 'idle',
    isShowCreateOrEditModal: false,
    createOrEditModel: null,
    isShowConfirmDeleteModal: false
};

const chuyenNganhTotNghiepSlice = createSlice({
    name: 'chuyenNganhTotNghiep',
    initialState,
    reducers: {
        setChuyenNganhTotNghiepList: (state, action: PayloadAction<TS_ChuyenNganhTotNghiep[]>) => {
            state.listData = action.payload;
        },
        setChuyenNganhTotNghiepStatus: (state, action: PayloadAction<ChuyenNganhTotNghiepState['status']>) => {
            state.status = action.payload;
        },
        setChuyenNganhTotNghiepSelectedId: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        insertChuyenNganhTotNghiepSuccess: (state, action: PayloadAction<TS_ChuyenNganhTotNghiep>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateChuyenNganhTotNghiepSuccess: (state, action: PayloadAction<TS_ChuyenNganhTotNghiep>) => {
            const index = state.listData.findIndex((x) => x.ID_chuyen_nganh === action.payload.ID_chuyen_nganh);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteChuyenNganhTotNghiepSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((x) => x.ID_chuyen_nganh !== action.payload);
            state.isShowConfirmDeleteModal = false;
        },
        setChuyenNganhTotNghiepCreateOrEditModel: (state, action: PayloadAction<TS_ChuyenNganhTotNghiep | null>) => {
            state.createOrEditModel = action.payload;
        },
        setChuyenNganhTotNghiepShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setChuyenNganhTotNghiepShowConfirmDeleteModal: (
            state,
            action: PayloadAction<{ show: boolean; id?: number }>
        ) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        resetChuyenNganhTotNghiepState: () => initialState
    }
});

export const {
    setChuyenNganhTotNghiepList,
    setChuyenNganhTotNghiepStatus,
    setChuyenNganhTotNghiepSelectedId,
    insertChuyenNganhTotNghiepSuccess,
    updateChuyenNganhTotNghiepSuccess,
    deleteChuyenNganhTotNghiepSuccess,
    setChuyenNganhTotNghiepCreateOrEditModel,
    setChuyenNganhTotNghiepShowCreateOrEditModal,
    setChuyenNganhTotNghiepShowConfirmDeleteModal,
    resetChuyenNganhTotNghiepState
} = chuyenNganhTotNghiepSlice.actions;

export const ChuyenNganhTotNghiepReducer = chuyenNganhTotNghiepSlice.reducer;
